import { connect } from 'react-redux';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import _get from 'lodash/get';

import Modal from 'kepler/lib/components/Modal';
import ModalBody from 'kepler/lib/components/ModalBody';
import { locationUpdate } from '../actions/action-contact-location';
import LogIn from '../components/LogIn';
import { closeModalContainer } from '../actions/action-login-modal';
import { dispatchLogin } from '../actions/action-login-redirect';
import { trackLink, trackPage } from '../../lib/analytics-helper';
import i18n from '../../lib/reacti18n';
import Page from '../../lib/page';
import * as shape from '../constants/PropTypesShapes';
import { chatType } from '../constants/UtilVariables';

const shouldShowChatBotForLoggedOutUser = Page.isShowChatFlag();

const CHANNEL_CHATBOT = chatType.chatBot;
const CHANNEL_LIVECHAT = chatType.liveChat;

class ModalContainer extends Component {
  // Send FPTi request when intermediate page open
  componentDidUpdate() {
    if (this.props.isModalOpen) {
      trackPage({ id: this.props.FPTITrackerId, link: 'smarthelp-intermediate|open' });
    }
  }

  showLoginPage() {
    const pathname = window.location.pathname.slice(3);
    const currentUri = `${window.location.origin}${pathname}`;
    const topic = {};

    if (this.props.channel === CHANNEL_CHATBOT || this.props.channel === CHANNEL_LIVECHAT) {
      const topicRefId = _get(this.props.selectResult, 'topicTreeSelectResult.topicRefId');
      const topicId = _get(this.props.selectResult, 'topicTreeSelectResult.topicId');
      const topicName = _get(this.props.selectResult, 'topicTreeSelectResult.topicName');

      if (topicRefId && topicId && topicName && shouldShowChatBotForLoggedOutUser) {
        topic.topicId = topicId;
        topic.topicName = topicName;
        topic.topicRefId = topicRefId;
      }
    }

    trackLink({ id: this.props.FPTITrackerId, link: `smarthelp-intermediate|login|${this.props.channel}` });
    return this.props.dispatchLogin(currentUri, this.props.channel, topic);
  }
  showGuestPage() {
    trackLink({ id: this.props.FPTITrackerId, link: `smarthelp-intermediate|guest|${this.props.channel}` });
    return this.props.locationUpdate({ pageName: 'callUs' });
  }

  closeModal() {
    trackLink({ id: this.props.FPTITrackerId, link: 'smarthelp-intermediate|close' });
    return this.props.closeModalContainer();
  }
  render() {
    return (
      <div>
        <Modal
          isOpen={this.props.isModalOpen} type="dialog" width="medium"
          onCancel={() => this.closeModal()}
        >
          <ModalBody>
            <LogIn
              content={this.props.content}
              channelType={this.props.channel}
              clickAction={() => this.showLoginPage()}
              linkAction={() => this.showGuestPage()}
            />
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  // emailUs--> Intent selected and email--> No intent selected
  const channels = {
    email: 'emailUs',
    callUs: 'callUs',
    emailUs: 'emailUs',
    chatBot: CHANNEL_CHATBOT,
    liveChat: CHANNEL_CHATBOT,
  };
  return {
    content: i18n.message(`smarthelp/${channels[state.modal.channel]}`),
    isModalOpen: state.modal.isModalOpen,
    channel: state.modal.channel,
    selectResult: state.selectResult,
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators({ closeModalContainer, dispatchLogin, locationUpdate }, dispatch);
}

ModalContainer.propTypes = {
  isModalOpen: PropTypes.bool.isRequired,
  locationUpdate: PropTypes.func.isRequired,
  dispatchLogin: PropTypes.func.isRequired,
  closeModalContainer: PropTypes.func.isRequired,
  content: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  channel: PropTypes.string.isRequired,
  selectResult: PropTypes.shape(shape.SELECT_RESULT).isRequired,
  FPTITrackerId: PropTypes.string,
};

ModalContainer.defaultProps = {
  content: {
    login: {
      guestMessage: '',
      header: '',
      instruction: '',
      login: '',
      loginMessage: '',
      message: '',
      trouble: '',
    },
  },
  FPTITrackerId: 'intermediatePage',
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalContainer);
